import SEO from "../../components/seo";
import LayoutTwo from "../../layouts/LayoutTwo";

const Wrapper = ({ seoTitle, children }) => {
  return (
    <div>
      <SEO titleTemplate={seoTitle} description={seoTitle} />
      <LayoutTwo>
        <div className="container other_pages_wrapper">
          <div className="title_con">
            <h3 className="underlined">{seoTitle}</h3>
          </div>
          <div className="content_con">{children}</div>
        </div>
      </LayoutTwo>
    </div>
  );
};

export default Wrapper;
